<template>
  <div :class="classes.wrapper">
    <Header />
    <Content />
    <Footer />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Header from "../../Header.vue";
import Footer from "../../Footer.vue";
import Content from "../../Content.vue";
import { createUseStyles } from "@fresh8/vue-jss/src";

export default defineComponent({
  name: "Billboard",
  components: {
    Header,
    Content,
    Footer
  },
  setup() {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const classes = useStyles();

    return {
      classes
    };
  }
});

const useStyles = createUseStyles({
  wrapper: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  }
});
</script>
